import  React,{ memo, Fragment,useState,useEffect } from 'react'

// React-bootstrap
import { Row, Col,  FormCheck, Form, Button,Alert } from 'react-bootstrap'

// Components
import Card from '../../../../../components/bootstrap/card'
import { clearStoragePreservingReportColumns } from '../../../../../utilities/reportColumnStorage'

// Router
import { useNavigate } from 'react-router-dom'; // version 5.2.0
import { loginService, verifyOtpService, sendOtpService, checkSsoService, ssoLoginService } from '../../../../../services/UserService';

const SignIn = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [signInError, setSignInError] = useState(null); // State to hold sign-in error
    const [step, setStep] = useState("email_check"); // email_check | password_input | otp
    const [otp, setOtp] = useState("");
    const [otpMethod, setOtpMethod] = useState('');
    const [maskedContact, setMaskedContact] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [mobile, setMobile] = useState('');

    const handleEmailCheck = async (e) => {
        e.preventDefault();
        setSignInError(null);
        if (!email) {
            setSignInError('Please enter an email address.');
            return;
        }
        
        try {
            const response = await checkSsoService(email);
            if (response.data && response.data.sso_required) {
                // SSO is required, fetch the auth url
                const ssoRes = await ssoLoginService(email);
                if (ssoRes.data && ssoRes.data.auth_url) {
                    window.location.href = ssoRes.data.auth_url; // Redirect to Microsoft
                }
            } else {
                // SSO not required, ask for password
                setStep("password_input");
            }
        } catch (error) {
            console.error('Error checking SSO:', error);
            // Default to normal login if service fails or not found
            setStep("password_input");
        }
    };

    const handleSignIn = async (e) => {
      e.preventDefault();
      const userDetails = {
        email: email,
        password: password
    }
    
      // Perform API call for sign in
      try {
        clearStoragePreservingReportColumns();
        console.log('e',userDetails)
        const response = await loginService(userDetails);
        console.log('login response--',response)
        if (response.status === 202 && response.data?.mfa_required) {
            setEmail(email);
            setStep("otp");
            setSignInError(null);
            setMobile(response.data.mobile)
            
        }
        else if (response.status === 202) {
          // Handle successful sign-in (e.g., redirect to dashboard)
          console.log('Sign-in successful!');
          localStorage.setItem('token', response.data.data.token);
          localStorage.setItem('role', response.data.data.role);
          localStorage.setItem('name', response.data.data.name);
          localStorage.setItem('iec_no', response.data.data.iec_no);
          localStorage.setItem('group_id', response.data.data.group_id);

          // Use a timeout to ensure localStorage write is complete
            setTimeout(() => {
                navigate('/dashboard/alternate-dashboard');
            }, 300);
        
        } else {
           // Handle sign-in error (e.g., show error message)
           console.error('Sign-in failed');
           setSignInError('Invalid email or password.'); // Set sign-in error message

         }
      } catch (error) {
        console.error('Error during sign-in:', error);
        setSignInError('Invalid email or password.'); // Set sign-in error message

      }
    };

    const handleOtpVerification = async (e) => {
        e.preventDefault();
        try {
          const res = await verifyOtpService({
            email: email,
            otp: otp,
          });
          if (res.data.status === 200) {
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("role", res.data.data.role);
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("iec_no", res.data.data.iec_no);
            localStorage.setItem("group_id", res.data.data.group_id);
            navigate("/dashboard/alternate-dashboard");
            window.location.reload();
          }
        } catch (err) {
            setOtp("")
            if (err.response.data.status === 400) {
                setSignInError("Invalid or expired OTP")
            } else if (err.response.data.status === 403) {
              setSignInError("Maximum OTP attempts exceeded. Please login again");
              setTimeout(() => {
                navigate("/"); // redirect to login page after 3 attempts
                window.location.reload();
              }, 1500); 
            } else {
                 setSignInError ("OTP verification failed");
             }
        }
      };
    useEffect(() => {
        const hash = window.location.hash || window.location.search;
        if (hash && hash.includes("token=")) {
            const queryParams = new URLSearchParams(hash.includes("?") ? hash.split("?")[1] : hash.replace("#", ""));
            const token = queryParams.get("token");
            const role = queryParams.get("role");
            const name = queryParams.get("name");
            const iec_no = queryParams.get("iec_no");
            const group_id = queryParams.get("group_id");

            if (token) {
                clearStoragePreservingReportColumns();
                localStorage.setItem("token", token);
                if (role) localStorage.setItem("role", role);
                if (name) localStorage.setItem("name", name);
                if (iec_no) localStorage.setItem("iec_no", iec_no);
                if (group_id) localStorage.setItem("group_id", group_id);

                navigate("/dashboard/alternate-dashboard");
                return;
            }
        }

        const token = localStorage.getItem('token');
        if (token) {
            navigate("/dashboard/alternate-dashboard");
        }
    }, [navigate]);

    const handleMethodSelection = async (method) => {
        setOtpMethod(method);
        setShowOtpInput(true);
        if (method === "sms" || method === "whatsapp") {
            if (mobile) {
                const maskedMobile = `91xxxxxx${mobile.slice(-4)}`;
                setMaskedContact(maskedMobile);
            }
        } else if (method === "email") {
            const maskedEmail = email[0] + '******' + email.slice(email.indexOf('@'));
            setMaskedContact(maskedEmail);
        }
        await sendOtpService(email, method);
    };
    

    return (
        <Fragment>
            <section className="iq-auth-page">
                <Row className="d-flex align-items-center justify-content-center  w-100" style={{height:"90vh"}}>
                    <Col md="10" xl="10">
                        <Card className="p-4">
                            <Card.Body>
                                <h3 className="text-center">Sign In</h3>
                                <p className="text-center">Sign in to stay connected</p>
                                <Form onSubmit={step === "email_check" ? handleEmailCheck : (step === "password_input" ? handleSignIn : handleOtpVerification)}>
                                {step === "email_check" ? (
                                <>
                                 <Form.Group className="mb-3">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email"
                                    required
                                    />
                                </Form.Group>
                                </>
                                ) : step === "password_input" ? (
                                <>
                                 <Form.Group className="mb-3">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                    type="email"
                                    value={email}
                                    disabled
                                    readOnly
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter password"
                                    required
                                    />
                                </Form.Group>
                                </>
                                ) : (
                                    <>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Select OTP Delivery Method</Form.Label>
                                        <div className="d-flex gap-3">
                                            <FormCheck
                                                type="radio"
                                                id="sms"
                                                label="SMS"
                                                name="otpMethod"
                                                onChange={() => handleMethodSelection("sms")}
                                                checked={otpMethod === "sms"}
                                                
                                            />
                                            <FormCheck
                                                type="radio"
                                                id="whatsapp"
                                                label="WhatsApp"
                                                name="otpMethod"
                                                onChange={() => handleMethodSelection("whatsapp")}
                                                checked={otpMethod === "whatsapp"}
                                            />
                                            <FormCheck
                                                type="radio"
                                                id="email"
                                                label="Email"
                                                name="otpMethod"
                                                onChange={() => handleMethodSelection("email")}
                                                checked={otpMethod === "email"}
                                            />
                                        </div>
                                    </Form.Group>

                                    {showOtpInput && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Enter OTP sent to {maskedContact}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                placeholder="Enter 6-digit OTP"
                                            />
                                        </Form.Group>
                                    )}
                                </>
                            )}
                                <div className="d-flex justify-content-between">
                                    {/* <Form.Check className="d-inline-block mt-2 pt-1">
                                        <FormCheck.Input type="checkbox" id="customCheck11"></FormCheck.Input>
                                        <Form.Check.Label htmlFor="customCheck11">Remember Me</Form.Check.Label>
                                    </Form.Check> */}
                                    {/* <Link to="/auth/reset-password">Forget password</Link> */}
                                </div>
                                <div className="text-center mt-2 pb-3">
                                    <Button type="submit"> 
                                        {step === "email_check" ? "Next" : (step === "password_input" ? "Sign In" : "Verify OTP")}
                                    </Button>
                                </div>
                                </Form>
                                {signInError && <Alert variant="danger">{signInError}</Alert>} {/* Display sign-in error message */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </section>
        </Fragment>
    )
}

SignIn.displayName = "SignIn"
export default SignIn
